import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./CaseFormPopup.css";
import Translate from "../helpers/Translate";

// Register custom size style for pixel values

import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { Conversation } from "@twilio/conversations/lib/conversation";
import CaseFormSuccessModal from "./CaseFormSuccessModal";

const Quill = ReactQuill.Quill;

const Size = Quill.import("attributors/style/size");
Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "24px",
  "32px",
  "48px",
];
Quill.register(Size, true);

const quillIcons = Quill.import("ui/icons");
quillIcons.image =
  '<svg viewBox="0 0 18 18"><path class="ql-stroke" d="M6.5,8.5l4.9-4.9c1.6-1.6,4.1-1.6,5.7,0s1.6,4.1,0,5.7l-7,7c-2.2,2.2-5.8,2.2-8,0s-2.2-5.8,0-8l6.1-6.1c1.3-1.3,3.4-1.3,4.7,0s1.3,3.4,0,4.7l-5.2,5.2c-0.8,0.8-2.1,0.8-2.8,0s-0.8-2.1,0-2.8l4.6-4.6"/></svg>';

// Adds files selected from Quill toolbar to the attachment list
let addQuillAttachments = null;
const imageHandler = function () {
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute(
    "accept",
    [
      "image/*",
      "application/pdf",
      "application/xml",
      "text/xml",
      ".xml",
      ".xls",
      ".xlsx",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ".doc",
      ".docx",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ].join(","),
  );
  input.setAttribute("multiple", "multiple");
  input.click();
  input.onchange = async () => {
    const files = Array.from((input && input.files) || []);
    if (!files.length) return;
    if (typeof addQuillAttachments === "function") {
      addQuillAttachments(files);
    }
  };
};

const quillModules = {
  toolbar: {
    container: [
      [{ font: [] }],
      [
        {
          size: [
            "10px",
            "12px",
            "14px",
            "16px",
            "18px",
            "24px",
            "32px",
            "48px",
          ],
        },
      ],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image"],
      ["clean"],
    ],
    handlers: {
      image: imageHandler,
    },
  },
};

const PRIMARY_GID = "ca6f18bc-c995-467e-8d88-b2bf01284b9e";

class CaseFormPopup extends Component {
  quillRef = null;

  getFieldTerminology = () => {
    return {
      system: {
        labelId: "caseform.productArea",
        labelDefault: "Product Areas",
        selectId: "caseform.select.productArea",
        selectDefault: "Select Product Area",
        loadingId: "caseform.loading.productAreas",
        loadingDefault: "Loading product areas...",
        errorId: "caseform.error.productAreas",
        errorDefault: "Error loading product areas",
        descriptionLabel: "Product Areas",
      },
      scenario: {
        labelId: "caseform.module",
        labelDefault: "Modules",
        selectId: "caseform.select.module",
        selectDefault: "Select Module",
        loadingId: "caseform.loading.modules",
        loadingDefault: "Loading modules...",
        errorId: "caseform.error.modules",
        errorDefault: "Error loading modules",
        descriptionLabel: "Modules",
      },
      topic: {
        labelId: "caseform.feature",
        labelDefault: "Features",
        selectId: "caseform.select.feature",
        selectDefault: "Select Feature",
        loadingId: "caseform.loading.features",
        loadingDefault: "Loading features...",
        errorId: "caseform.error.features",
        errorDefault: "Error loading features",
        descriptionLabel: "Features",
      },
    };
  };

  getCaseFormEndpoints = () => {
    return {
      systems: "areas",
      scenarios: "modules",
      topics: "features",
      aiClassify: "ai-classify-case-sf",
    };
  };

  addAttachments = (selected = []) => {
    if (!selected.length) {
      return;
    }

    this.setState((prevState) => {
      const existingKeys = new Set(
        prevState.attachments.map(
          (f) => `${f.name}-${f.size}-${f.lastModified}`,
        ),
      );
      const deduped = selected.filter((f) => {
        const key = `${f.name}-${f.size}-${f.lastModified}`;
        if (existingKeys.has(key)) return false;
        existingKeys.add(key);
        return true;
      });

      if (!deduped.length) {
        return null;
      }

      return {
        attachments: [...prevState.attachments, ...deduped],
        attachmentError: null,
      };
    });
  };

  uploadCaseAttachmentsByCaseId = async (caseId) => {
    const { attachments } = this.state;
    if (!attachments.length) {
      return [];
    }
    if (!caseId) {
      throw new Error("CaseId is required for uploading case attachments.");
    }

    const attachmentApiUrl = `${process.env.REACT_APP_PARTNER_URL}/salesforce/case-attachments`;

    const parseResponse = async (resp) => {
      let data = null;
      try {
        data = await resp.json();
      } catch (e) {
        data = null;
      }
      return data;
    };

    // Preferred path: multipart upload keeps payloads smaller than base64 JSON.
    const formData = new FormData();
    formData.append("GroupId", this.props.gid || "");
    formData.append("CaseId", caseId);
    attachments.forEach((file) => {
      formData.append("attachments", file, file.name);
    });

    const multipartResp = await fetch(attachmentApiUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    });

    if (multipartResp.ok) {
      return parseResponse(multipartResp);
    }
  };

  removeAttachment = (idx) => {
    this.setState((prevState) => ({
      attachments: prevState.attachments.filter((_, index) => index !== idx),
    }));
  };

  waitForFieldLoadingToFinish = (loadingKey, timeoutMs = 8000) =>
    new Promise((resolve) => {
      const start = Date.now();
      const check = () => {
        if (!this.state[loadingKey]) {
          resolve();
          return;
        }
        if (Date.now() - start >= timeoutMs) {
          resolve();
          return;
        }
        setTimeout(check, 50);
      };
      check();
    });

  // Prefill fields from an object (used by parent via ref)
  prefillFields = async (fields = {}) => {
    this.setState({ prefillLoading: true });
    try {
      // Always show the popup first
      if (!this.state.show) this.setState({ show: true });
      // Only set fields that exist in state
      const allowed = ["system", "scenario", "topic", "subject", "description"];
      const update = {};
      for (const key of allowed) {
        if (fields[key] !== undefined) update[key] = fields[key];
      }

      console.log("Prefilling case form with:", update);

      // 4. Set subject and description using handleChange for controlled updates
      if (update.subject) {
        await this.handleChange({
          target: { name: "subject", value: update.subject },
        });
      }
      if (update.description) {
        await this.handleChange({
          target: { name: "description", value: update.description },
        });
      }

      // 1. Set system and wait for systems to load if needed
      if (update.system) {
        if (!this.state.systems.length) {
          await this.fetchSystems();
        }
        await new Promise((resolve) =>
          this.setState({ system: update.system }, resolve),
        );
        await this.handleChange({
          target: { name: "system", value: update.system },
        });
        // Wait for scenarios request to finish (including empty results)
        await this.waitForFieldLoadingToFinish("scenariosLoading");
      }
      // 2. Set scenario and wait for topics to load if needed
      if (update.scenario) {
        await new Promise((resolve) =>
          this.setState({ scenario: update.scenario }, resolve),
        );
        await this.handleChange({
          target: { name: "scenario", value: update.scenario },
        });
        // Wait for topics request to finish (including empty results)
        await this.waitForFieldLoadingToFinish("topicsLoading");
      }
      // 3. Set topic
      if (update.topic) {
        await new Promise((resolve) =>
          this.setState({ topic: update.topic }, resolve),
        );
      }
    } finally {
      this.setState({ prefillLoading: false });
    }
  };
  constructor(props) {
    super(props);
    this.state = {
      system: "",
      scenario: "",
      topic: "",
      subject: "",
      description: "",
      show: true,
      systems: [],
      systemsLoading: false,
      systemsError: null,
      scenarios: [],
      scenariosLoading: false,
      scenariosError: null,
      topics: [],
      topicsLoading: false,
      topicsError: null,
      submitLoading: false,
      caseNumberModal: false,
      caseId: "",
      prefillLoading: false,
      caseNumber: "",
      attachments: [],
      attachmentError: null,
      chatSummary: "",
    };
  }

  componentDidMount() {
    addQuillAttachments = (files) => this.addAttachments(files);
    this.fetchSystems();
    // If the popup is already shown on mount, attempt AI prefill
    if (this.state.show && !this._aiPrefilled) {
      this.fetchAiPrefill();
    }
  }

  componentWillUnmount() {
    addQuillAttachments = null;
  }

  componentDidUpdate(prevProps, prevState) {
    // When the popup is opened, fetch AI prefill if we haven't already
    if (!prevState.show && this.state.show && !this._aiPrefilled) {
      this.fetchAiPrefill();
    }

    // If parent provided a pending prefill prop after mount, apply it
    if (
      prevProps.pendingPrefill !== this.props.pendingPrefill &&
      this.props.pendingPrefill &&
      !this._aiPrefilled
    ) {
      this._aiPrefilled = true;
      this.setState({ prefillLoading: true }, async () => {
        try {
          await this.prefillFields(this.props.pendingPrefill);
        } catch (e) {
          console.error("Error applying pending prefill on update", e);
        } finally {
          this.setState({ prefillLoading: false });
        }
      });
    }
  }

  fetchAiPrefill = async () => {
    const endpoints = this.getCaseFormEndpoints();
    this._aiPrefilled = true; // avoid duplicate calls
    this.setState({ prefillLoading: true });
    // Build chat history: prefer explicit prop, fallback to store state
    let chatHistory = this.props.userChatHistory;
    if (!chatHistory) {
      try {
        let storeState = null;
        if (
          this.props.store &&
          typeof this.props.store.getState === "function"
        ) {
          storeState = this.props.store.getState();
        } else if (
          this.props.bookingApp &&
          this.props.bookingApp.callbacks &&
          typeof this.props.bookingApp.callbacks.getStore === "function"
        ) {
          storeState = this.props.bookingApp.callbacks.getStore().getState();
        }
        if (storeState) {
          chatHistory =
            require("../ChatStore").getChatHistoryOnlyUser(storeState);
        }
      } catch (e) {
        console.error("Failed to build chat history for AI prefill", e);
      }
    }

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/salesforce/${endpoints.aiClassify}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userChatHistory: chatHistory,
            GroupId: this.props.gid,
          }),
        },
      );
      let aiCaseData = null;
      if (resp.ok) aiCaseData = await resp.json();

      if (aiCaseData) {
        const prefillObj = {
          system: aiCaseData.system || "",
          scenario: aiCaseData.scenario || "",
          topic: aiCaseData.topic || "",
          subject: aiCaseData.subject || "",
          description:
            aiCaseData.case_description || aiCaseData.description || "",
        };

        this.setState({ chatSummary: aiCaseData.chat_summary || "" });

        // Ensure systems are loaded before prefill if necessary
        if (!this.state.systems.length) await this.fetchSystems();

        try {
          await this.prefillFields(prefillObj);
        } catch (e) {
          console.error("Error pre-filling fields from AI response", e);
        }
      }
    } catch (err) {
      console.error("Failed to fetch AI case data", err);
    } finally {
      this.setState({ prefillLoading: false });
    }
  };

  fetchSystems = async () => {
    const endpoints = this.getCaseFormEndpoints();
    this.setState({ systemsLoading: true, systemsError: null });
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/salesforce/${endpoints.systems}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );
      if (!resp.ok) throw new Error("Failed to fetch systems");
      const data = await resp.json();
      // Expecting array of system names or objects with name property
      this.setState({
        systems: Array.isArray(data) ? data : [],
        systemsLoading: false,
      });
    } catch (err) {
      this.setState({ systemsError: err.message, systemsLoading: false });
    }
  };

  open = () => this.setState({ show: true });
  close = () => {
    this.setState({ show: false });
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  handleChange = async (e) => {
    const endpoints = this.getCaseFormEndpoints();
    // For ReactQuill, e can be a string (HTML)
    if (e && e.target) {
      const { name, value } = e.target;
      this.setState({ [name]: value });
      if (name === "system") {
        this.setState({
          scenario: "",
          scenarios: [],
          scenariosLoading: true,
          scenariosError: null,
          topic: "",
          topics: [],
          topicsLoading: false,
          topicsError: null,
        });
        try {
          const resp = await fetch(
            `${process.env.REACT_APP_PARTNER_URL}/salesforce/${endpoints.scenarios}`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ system: value }),
            },
          );
          if (!resp.ok) throw new Error("Failed to fetch scenarios");
          const data = await resp.json();
          this.setState({
            scenarios: Array.isArray(data) ? data : [],
            scenariosLoading: false,
          });
        } catch (err) {
          this.setState({
            scenariosError: err.message,
            scenariosLoading: false,
            prefillLoading: false,
          });
        }
      }
      if (name === "scenario") {
        this.setState({
          topic: "",
          topics: [],
          topicsLoading: true,
          topicsError: null,
        });
        try {
          const resp = await fetch(
            `${process.env.REACT_APP_PARTNER_URL}/salesforce/${endpoints.topics}`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                system: this.state.system,
                scenario: value,
              }),
            },
          );
          if (!resp.ok) throw new Error("Failed to fetch topics");
          const data = await resp.json();
          this.setState({
            topics: Array.isArray(data) ? data : [],
            topicsLoading: false,
          });
        } catch (err) {
          this.setState({
            topicsError: err.message,
            topicsLoading: false,
            prefillLoading: false,
          });
        }
      }
    } else if (typeof e === "string") {
      // ReactQuill change
      this.setState({ description: e });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitLoading: true, attachmentError: null });
    const terminology = this.getFieldTerminology();
    // Remove single quotes from system, scenario, and topic
    // const clean = (val) =>
    //   typeof val === "string" ? val.replace(/'/g, "") : val;
    // Prepend System, Scenario, Topic to description
    const systemLabel = this.state.system
      ? `${terminology.system.descriptionLabel}: ${this.state.system}`
      : "";
    const scenarioLabel = this.state.scenario
      ? `${terminology.scenario.descriptionLabel}: ${this.state.scenario}`
      : "";
    const topicLabel = this.state.topic
      ? `${terminology.topic.descriptionLabel}: ${this.state.topic}`
      : "";
    // Append chat history if provided
    let chatHistory = this.props.chatHistory;
    const chatHistoryHtml = chatHistory || "";
    //console.log("Original chat history:", chatHistory);
    let chatHistorySection = chatHistoryHtml
      ? `<br /><br /><b>Chat History:</b><br />${chatHistoryHtml}`
      : "";
    let descriptionWithLabels =
      [systemLabel, scenarioLabel, topicLabel].filter(Boolean).join("\n") +
      "\n\n" +
      "Chat Summary: " +
      this.state.chatSummary;
    // Truncate to max 32000 characters
    // if (descriptionWithLabels.length > 32000) {
    //   descriptionWithLabels = descriptionWithLabels.slice(0, 32000);
    // }

    console.log("this.props.accountId", this.props.accountId);
    console.log("this.props.contactId", this.props.contactId);
    const rawStepsToReproduce =
      "<b>Chat Summary:</b> " + this.state.description + chatHistorySection;
    const stepsToReproduce =
      rawStepsToReproduce.length > 32767
        ? rawStepsToReproduce.slice(0, 32767)
        : rawStepsToReproduce;
    const body = {
      System__c: this.state.system,
      Scenario__c: this.state.scenario,
      Topic__c: this.state.topic,
      AccountId: this.props.accountId,
      ContactId: this.props.contactId,
      Subject: this.state.subject,
      Description: descriptionWithLabels,
      RecordTypeId: "012600000004vJ7AAI",
      Origin: "Portal",
      GroupId: this.props.gid,
      ConversationId: this.props.directline.conversationId,
      Steps_to_Reproduce__c: stepsToReproduce,
    };
    // Print body as JSON string
    console.log(JSON.stringify(body));
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/salesforce/case-new`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
      );
      const data = await resp.json();
      console.log("Case creation response:", data);
      //console.log("Case creation response status:", resp.ok, resp.status);
      if (!resp.ok) {
        this.setState({
          submitLoading: false,
          genericError: true,
        });
        return;
      }
      if (data && data.CaseNumber) {
        const createdCaseId = data.caseId || data.CaseId || "";
        const createdCaseNumber = data.CaseNumber || "";
        try {
          await this.uploadCaseAttachmentsByCaseId(createdCaseId);
        } catch (uploadErr) {
          console.error("Case created but attachment upload failed", uploadErr);
        }

        const hasParentCaseSuccessHandler =
          typeof this.props.onCaseFormSuccess === "function";

        this.setState(
          {
            submitLoading: false,
            caseNumberModal: !hasParentCaseSuccessHandler,
            caseNumber: createdCaseNumber,
            caseId: createdCaseId,
            attachments: [],
            attachmentError: null,
            show: false, // Hide the previous popup
          },
          () => {
            if (hasParentCaseSuccessHandler) {
              this.props.onCaseFormSuccess({
                caseId: createdCaseId,
                caseNumber: createdCaseNumber,
              });
              if (typeof this.props.onSuccessOk === "function") {
                this.props.onSuccessOk();
              }
            }
          },
        );

        // Use Translate component for localized message
        // const msg = (
        //   <Translate
        //     input={`Case Created!\nCase Number: ${data.CaseNumber}`}
        //     lang={this.props.lang || "en"}
        //   />
        // );
        const salesForceURL =
          this.props.gid === PRIMARY_GID
            ? "https://portal.avenhospitality.com/s/case/"
            : "https://hospslns--sit.sandbox.my.site.com/s/case/";

        const msg = `Case Created!\nCase Number: [${createdCaseNumber}](${salesForceURL}${createdCaseId}/)`;
        console.log("Dispatching handover_to_salesforce with message:", msg);
        if (this.props.directline && this.props.directline.conversationId) {
          fetch(process.env.REACT_APP_API_URL + "/sendmessageactivityByBot", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              conversationId: this.props.directline.conversationId,
              message: msg,
              from: Math.random(),
              summary: "",
            }),
          }).catch((err) => {
            console.error("Bmb ticket creation failed :(.\n", err);
          });

          var msgpayload = {
            gid: this.props.gid,
            iid: this.props.iid,
            pid: this.props.pid,
            vid: this.props.vid,
            sid: this.props.sid,
            cid: this.props.directline.conversationId,
            time: new Date().toISOString(),
            source: "Bot",
            message: msg,
            tag: "",
            agentId: "",
            languageCode: this.props.lang,
          };

          fetch(process.env.REACT_APP_API_URL + "/saveMessage", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(msgpayload),
          }).catch((err) => {
            console.error("Bmb livechat logging failed :(.");
            console.error(err);
          });
        }
      } else {
        this.setState({ submitLoading: false });
        this.close();
      }
      if (this.props.onSubmit) {
        this.props.onSubmit(data);
      }
      if (this.props.loadClosedCases) {
        this.props.loadClosedCases();
      }
    } catch (err) {
      this.setState({
        submitLoading: false,
        genericError: true,
      });
      // alert("Error creating case: " + err.message);
    }
  };

  render() {
    const terminology = this.getFieldTerminology();
    const {
      show,
      system,
      scenario,
      topic,
      subject,
      description,
      systems,
      systemsLoading,
      systemsError,
      scenarios,
      scenariosLoading,
      scenariosError,
      topics,
      topicsLoading,
      topicsError,
    } = this.state;
    return (
      <>
        <Modal isOpen={show} toggle={this.close}>
          <ModalHeader toggle={this.close}>
            <FormattedMessage
              id="caseform.title"
              defaultMessage="Submit a Case"
            />
          </ModalHeader>
          {/* Loader overlay for prefill */}
          {this.state.prefillLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.7)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="modern-spinner"></div>
            </div>
          )}
          {this.state.submitLoading ? (
            <div className="container">
              <div className="modern-spinner"></div>
            </div>
          ) : (
            <Form onSubmit={this.handleSubmit}>
              <ModalBody
                style={{
                  height: "calc(99vh - 72px)", // 72px is approx header+footer height
                  minHeight: "400px",
                  overflowY: "auto",
                  paddingBottom: 0,
                }}
              >
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="system">
                    <FormattedMessage
                      id={terminology.system.labelId}
                      defaultMessage={terminology.system.labelDefault}
                    />
                  </Label>
                  <Input
                    type="select"
                    name="system"
                    id="system"
                    value={system}
                    onChange={this.handleChange}
                    required
                    disabled={systemsLoading}
                  >
                    {systemsLoading ? (
                      <FormattedMessage
                        id={terminology.system.loadingId}
                        defaultMessage={terminology.system.loadingDefault}
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id={terminology.system.selectId}
                        defaultMessage={terminology.system.selectDefault}
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    )}
                    {systemsError && (
                      <option value="" disabled>
                        <FormattedMessage
                          id={terminology.system.errorId}
                          defaultMessage={terminology.system.errorDefault}
                        />
                      </option>
                    )}
                    {Array.isArray(systems) &&
                      systems.map((sys, idx) => {
                        let value =
                          typeof sys === "object" && sys !== null
                            ? (sys.name ?? "")
                            : sys;
                        let label =
                          typeof sys === "object" && sys !== null
                            ? (sys.name ?? "")
                            : sys;
                        return (
                          <option key={value || idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="scenario">
                    <FormattedMessage
                      id={terminology.scenario.labelId}
                      defaultMessage={terminology.scenario.labelDefault}
                    />
                  </Label>
                  <Input
                    type="select"
                    name="scenario"
                    id="scenario"
                    value={scenario}
                    onChange={this.handleChange}
                    required
                    disabled={scenariosLoading || !system}
                  >
                    {scenariosLoading ? (
                      <FormattedMessage
                        id={terminology.scenario.loadingId}
                        defaultMessage={terminology.scenario.loadingDefault}
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id={terminology.scenario.selectId}
                        defaultMessage={terminology.scenario.selectDefault}
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    )}
                    {scenariosError && (
                      <option value="" disabled>
                        <FormattedMessage
                          id={terminology.scenario.errorId}
                          defaultMessage={terminology.scenario.errorDefault}
                        />
                      </option>
                    )}
                    {Array.isArray(scenarios) &&
                      scenarios.map((sc, idx) => {
                        let value =
                          typeof sc === "object" && sc !== null
                            ? (sc.name ?? "")
                            : sc;
                        let label =
                          typeof sc === "object" && sc !== null
                            ? (sc.name ?? "")
                            : sc;
                        return (
                          <option key={value || idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="topic">
                    <FormattedMessage
                      id={terminology.topic.labelId}
                      defaultMessage={terminology.topic.labelDefault}
                    />
                  </Label>
                  <Input
                    type="select"
                    name="topic"
                    id="topic"
                    value={topic}
                    onChange={this.handleChange}
                    required
                    disabled={topicsLoading || !scenario}
                  >
                    {topicsLoading ? (
                      <FormattedMessage
                        id={terminology.topic.loadingId}
                        defaultMessage={terminology.topic.loadingDefault}
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id={terminology.topic.selectId}
                        defaultMessage={terminology.topic.selectDefault}
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    )}
                    {topicsError && (
                      <option value="" disabled>
                        <FormattedMessage
                          id={terminology.topic.errorId}
                          defaultMessage={terminology.topic.errorDefault}
                        />
                      </option>
                    )}
                    {Array.isArray(topics) &&
                      topics.map((tp, idx) => {
                        let value =
                          typeof tp === "object" && tp !== null
                            ? (tp.name ?? "")
                            : tp;
                        let label =
                          typeof tp === "object" && tp !== null
                            ? (tp.name ?? "")
                            : tp;
                        return (
                          <option key={value || idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="subject">
                    <FormattedMessage
                      id="caseform.subject"
                      defaultMessage="Subject"
                    />
                  </Label>
                  <Input
                    type="text"
                    name="subject"
                    id="subject"
                    value={subject}
                    onChange={this.handleChange}
                    required
                  />
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="description">
                    <FormattedMessage
                      id="caseform.description"
                      defaultMessage="Description"
                    />
                  </Label>
                  <div
                    className="case-quill-wrapper"
                    style={{ position: "relative" }}
                  >
                    <ReactQuill
                      className="case-quill-editor"
                      ref={(el) => {
                        this.quillRef = el;
                        if (el && el.getEditor) {
                          window.quillRef = el.getEditor();
                        }
                      }}
                      theme="snow"
                      value={description}
                      onChange={this.handleChange}
                      modules={quillModules}
                    />
                  </div>
                </FormGroup>
                {this.state.attachments.length > 0 && (
                  <FormGroup className="case-attachments-group">
                    <Label>
                      <FormattedMessage
                        id="caseform.attachments"
                        defaultMessage="Attachments"
                      />
                    </Label>
                    <div style={{ marginTop: 10 }}>
                      {this.state.attachments.map((file, idx) => (
                        <div
                          key={`${file.name}-${file.size}-${file.lastModified}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px solid #eee",
                            borderRadius: 4,
                            padding: "6px 10px",
                            marginBottom: 6,
                          }}
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              marginRight: 10,
                            }}
                            title={file.name}
                          >
                            {file.name}
                          </span>
                          <Button
                            color="link"
                            type="button"
                            style={
                              this.props.buttonColor
                                ? {
                                    backgroundColor: this.props.buttonColor,
                                    borderColor: this.props.buttonColor,
                                    color: "#fff",
                                    padding: 0,
                                  }
                                : undefined
                            }
                            onClick={() => this.removeAttachment(idx)}
                          >
                            <FormattedMessage
                              id="caseform.attachments.remove"
                              defaultMessage="Remove"
                            />
                          </Button>
                        </div>
                      ))}
                    </div>
                    {this.state.attachmentError && (
                      <div style={{ color: "#c62828", marginTop: 8 }}>
                        {this.state.attachmentError}
                      </div>
                    )}
                  </FormGroup>
                )}
                {/* ...existing code... */}
              </ModalBody>
              <ModalFooter
                style={{
                  position: "sticky",
                  bottom: 0,
                  background: "#fff",
                  zIndex: 10,
                  borderTop: "1px solid #eee",
                  boxShadow: "0 -2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <Button
                  color="primary"
                  type="submit"
                  style={
                    this.props.buttonColor
                      ? {
                          backgroundColor: this.props.buttonColor,
                          borderColor: this.props.buttonColor,
                          color: "#fff",
                        }
                      : undefined
                  }
                >
                  <FormattedMessage
                    id="caseform.submit"
                    defaultMessage="Submit"
                  />
                </Button>{" "}
                <Button
                  color="secondary"
                  onClick={this.close}
                  type="button"
                  style={
                    this.props.buttonColor
                      ? {
                          backgroundColor: this.props.buttonColor,
                          borderColor: this.props.buttonColor,
                          color: "#fff",
                        }
                      : undefined
                  }
                >
                  <FormattedMessage
                    id="caseform.cancel"
                    defaultMessage="Cancel"
                  />
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Modal>
        <CaseFormSuccessModal
          isOpen={this.state.caseNumberModal}
          caseId={this.state.caseId}
          caseNumber={this.state.caseNumber}
          buttonColor={this.props.buttonColor}
          onClose={() => {
            this.setState({
              caseNumberModal: false,
              caseId: "",
              caseNumber: "",
            });
            this.close();
          }}
          onOk={() => {
            this.setState({
              caseNumberModal: false,
              caseId: "",
              caseNumber: "",
            });
            this.close();
            if (typeof this.props.onSuccessOk === "function") {
              this.props.onSuccessOk();
            }
          }}
          gid={this.props.gid}
        />
        {/* Generic Error Modal */}
        {this.state.genericError && (
          <Modal
            isOpen={this.state.genericError}
            toggle={() => {
              this.setState({ genericError: false });
              this.close();
            }}
          >
            <ModalHeader
              toggle={() => {
                this.setState({ genericError: false });
                this.close();
              }}
            >
              <FormattedMessage
                id="caseform.error.generic"
                defaultMessage="An error occurred while creating your case. Please try again later."
              />
            </ModalHeader>
            <ModalBody>
              <div style={{ marginBottom: 16 }}>
                <FormattedMessage
                  id="caseform.error.generic.message"
                  defaultMessage="An error occurred while creating your case. Please try again later."
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => {
                  this.setState({ genericError: false });
                  this.close();
                }}
                style={
                  this.props.buttonColor
                    ? {
                        backgroundColor: this.props.buttonColor,
                        borderColor: this.props.buttonColor,
                        color: "#fff",
                      }
                    : undefined
                }
              >
                <FormattedMessage
                  id="caseform.success.ok"
                  defaultMessage="OK"
                />
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  }
}

export default CaseFormPopup;
